import api from "./ApiUrl";

const url = "academic/v1/api";

export const postDefaultTenant = async (tenantId) => {
  const res = await api.get(`${url}/user/default/tenant/${tenantId}`);
  return res.data;
};

export const defaultTenant = async () => {
  const res = await api.get(`${url}/user/login/details`);
  return res.data;
};

export const profileDetails = async (token) => {
  const res = await api.get(`${url}/user/login/details`, {
    headers: {
      Authorization: `Bearer ${token}`, // or just token depending on your backend
    },
  });

  return res.data;
};

export const getUsers = async (page, size, search) => {
  const params = { page, size };

  if (search) {
    params.search = search;
  }
  const res = await api.get(`${url}/users/search`, {
    params,
  });
  return res.data;
};

export const createUsers = async (data) => {
  const res = await api.post(`${url}/users`, data);
  return res.data;
};

export const forgetUserPassword = async (data) => {
  const res = await api.put(`${url}/users/resset-password`, data);
  return res.data;
};

export const changeStatus = async (data) => {
  const res = await api.put(`${url}/users/status/${data}`);
  return res.data;
};

//Players
export const getPackageType = async () => {
  const res = await api.get(`${url}/player/package/type`);
  return res.data;
};

export const getPackageTypeEnum = async () => {
  const res = await api.get(`${url}/public/package-type`);
  return res.data;
};

export const getPackageDuration = async () => {
  const res = await api.get(`${url}/public/package/duration`);
  return res.data;
};

export const createPackageType = async (data) => {
  const res = await api.post(`${url}/player/package/type`, data);
  return res.data;
};

export const getPlayerSubscription = async () => {
  const res = await api.get(`${url}/player/subscription`);
  return res.data;
};

export const getAllReportPlayer = async (page, size, search) => {
  const params = { page, size };

  if (search) {
    params.search = search;
  }
  const res = await api.get(`${url}/report/player`, {
    params,
  });
  return res.data;
};

export const getPlayerSubscriptionSearch = async (status, search) => {
  const params = {};

  if (status?.trim()) {
    params.status = status;
  }

  if (search?.trim()) {
    params.search = search.trim();
  }

  const res = await api.get(`${url}/player/search/subscription`, {
    params,
  });
  return res.data;
};

export const createPlayerSubscription = async (data) => {
  const res = await api.post(`${url}/player/subscription`, data);
  return res.data;
};

//session

export const getSessionType = async () => {
  const res = await api.get(`${url}/api/sessions/types`);
  return res.data;
};

export const createSessionType = async (data) => {
  const res = await api.post(`${url}/api/sessions/types`, data);
  return res.data;
};

export const getSession = async () => {
  const res = await api.get(`${url}/api/sessions`);
  return res.data;
};

export const getSessionSearch = async (search, status) => {
  const params = {};

  if (search?.trim()) {
    params.search = search.trim();
  }

  if (status?.trim()) {
    params.status = status;
  }

  const res = await api.get(`${url}/api/sessions/search`, {
    params,
  });

  return res.data;
};

export const getStatus = async () => {
  const res = await api.get(`${url}/public/attendance/status`);
  return res.data;
};

export const createSession = async (data) => {
  const res = await api.post(`${url}/api/sessions`, data);
  return res.data;
};

//role

export const getPermissionByRoleId = async (id) => {
  const res = await api.get(`${url}/tenant-roles/${id}/permission`);
  return res.data;
};

export const createPermissionRoles = async (data) => {
  const res = await api.put(`${url}/tenant-roles/permission`, data);
  return res.data;
};

export const getRoles = async () => {
  const res = await api.get(`${url}/tenant-roles`);
  return res.data;
};

export const createRole = async (data) => {
  const res = await api.post(`${url}/tenant-roles`, data);
  return res.data;
};

export const updateRole = async (data) => {
  const res = await api.post(`${url}/tenant-roles`, data);
  return res.data;
};

export const createTenantUsers = async (data) => {
  const res = await api.post(`${url}/user/tenants`, data);
  return res.data;
};

export const getAllTenantUserData = async () => {
  const res = await api.get(`${url}/user/tenants`);
  return res.data;
};

export const createUserRoleMap = async (data) => {
  const res = await api.post(`${url}/user-tenants/role-map`, data);
  return res.data;
};

//coach

export const getCoachSkill = async () => {
  const res = await api.get(`${url}/public/coachSkill`);
  return res.data;
};

export const getCoach = async (page, size, search) => {
  const params = { page, size };

  if (search) {
    params.search = search;
  }
  const res = await api.get(`${url}/coach`, {
    params,
  });
  return res.data;
};

export const getCoachDropdown = async ({
  page = 0,
  size = 10,
  search = "",
}) => {
  const params = { page, size };

  if (search) {
    params.search = search;
  }

  const res = await api.get(`${url}/coach`, { params });
  return res.data;
};

export const downloadAllCoaches = async (search) => {
  const params = { search };
  if (search) {
    params.search = search;
  }
  params.download = true;
  const res = await api.get(`${url}/coach`, {
    params,
  });
  return res.data;
};

export const createAndUpdateCoach = async (data) => {
  const res = await api.post(`${url}/coach`, data);
  return res.data;
};

export const getCoachDailyAttendance = async (
  page,
  size,
  search,
  startDate,
  endDate,
  selectedSession,
  selectedStatus,
) => {
  const params = { page, size };

  if (search) {
    params.search = search;
  }
  if (startDate) {
    params.fromDate = startDate;
  }
  if (endDate) {
    params.toDate = endDate;
  }
  if (selectedSession) {
    params.sessionId = selectedSession;
  }
  if (selectedStatus) {
    params.status = selectedStatus;
  }

  const res = await api.get(`${url}/coach/daily/attendances`, {
    params,
  });
  return res.data;
};

export const getPlayersAttendance = async (
  page,
  size,
  search,
  startDate,
  endDate,
  selectedSession,
  selectedStatus,
) => {
  const params = { page, size };

  if (search) {
    params.search = search;
  }
  if (startDate) {
    params.fromDate = startDate;
  }
  if (endDate) {
    params.toDate = endDate;
  }
  if (selectedSession) {
    params.sessionId = selectedSession;
  }
  if (selectedStatus) {
    params.status = selectedStatus;
  }

  const res = await api.get(`${url}/admin/player/attendance`, {
    params,
  });
  return res.data;
};

export const downloadCoachDailyAttendances = async (
  search,
  startDate,
  endDate,
  selectedSession,
  selectedStatus,
) => {
  const params = {};

  if (search?.trim()) params.search = search;
  if (startDate) params.fromDate = startDate;
  if (endDate) params.toDate = endDate;
  if (selectedSession) params.sessionId = selectedSession;
  if (selectedStatus) params.status = selectedStatus;
  params.download = true;

  const res = await api.get(`${url}/coach/daily/attendances`, { params });
  return res.data;
};

export const getCoachAttendance = async (id) => {
  const res = await api.get(`${url}/coach/attendance/records/${id}`);
  return res.data;
};

export const getCoachMonthlyAttendance = async (page, size, search) => {
  const params = { page, size };

  if (search) {
    params.search = search;
  }
  const res = await api.get(`${url}/coach/monthly/attendances`, {
    params,
  });
  return res.data;
};

export const getCoachWeeklyAttendance = async (page, size, search) => {
  const params = { page, size };

  if (search) {
    params.search = search;
  }
  const res = await api.get(`${url}/coach/weekly/attendances`, {
    params,
  });
  return res.data;
};

//player

export const getPlayers = async (
  page,
  size,
  search,
  selectedDueList,
  selectedAgeCategory,
  selectedPaymentStatus,
  startDate,
  endDate,
) => {
  const params = { page, size };

  if (search) {
    params.search = search;
  }
  if (selectedDueList) {
    params.dueType = selectedDueList;
  }
  if (selectedAgeCategory) {
    params.ageCategory = selectedAgeCategory;
  }
  if (selectedPaymentStatus) {
    params.paymentStatus = selectedPaymentStatus;
  }

  if (startDate && endDate) {
    params.fromDate = startDate;
    params.toDate = endDate;
  }

  const res = await api.get(`${url}/player`, {
    params,
  });
  return res.data;
};

export const playerDiscountPackageAdd = async (data) => {
  const res = await api.put(`${url}/player/add/discount`, data);
  return res.data;
};

export const PaidPlayerPackageChange = async (data) => {
  const res = await api.put(`${url}/player/subscription/change`, data);
  return res.data;
};

export const getPaymentDetailsById = async (id) => {
  const res = await api.get(`${url}/player/payment/history/${id}`);
  return res.data;
};

export const postAssignPlayerCoach = async (data) => {
  const res = await api.put(`${url}/player/assigned/coach`, data);
  return res.data;
};

export const downloadAllPlayers = async (search) => {
  const params = { search };

  if (search) params.search = search;
  params.download = true;

  const res = await api.get(`${url}/player`, { params });
  return res.data;
};

export const getInquiry = async (page, size, search) => {
  const params = { page, size, status: "Enquiry" };

  if (search) {
    params.search = search;
  }
  const res = await api.get(`${url}/player/registration`, {
    params,
  });
  return res.data;
};

export const getRegisterList = async (page, size, search) => {
  const params = { page, size, status: "Registration" };

  if (search) {
    params.search = search;
  }
  const res = await api.get(`${url}/player/registration`, {
    params,
  });
  return res.data;
};

export const getUnpaidPlayers = async (page, size, search) => {
  const params = { page, size };

  if (search) {
    params.search = search;
  }
  const res = await api.get(`${url}/player/unpaid`, {
    params,
  });
  return res.data;
};

export const createAndUpdatePlayer = async (data) => {
  const res = await api.post(`${url}/player`, data);
  return res.data;
};

export const paymentStatusById = async (id) => {
  const res = await api.post(`${url}/player/status/${id}`);
  return res.data;
};

export const playerPayment = async (data) => {
  const res = await api.post(`${url}/player/add/payment`, data);
  return res.data;
};

export const generateQrCode = async (data) => {
  const res = await api.post(`${url}/public/generate/qr`, data);
  return res.data;
};

export const createAndUpdateRegisterPlayer = async (data) => {
  const res = await api.post(`${url}/player/registration/create-player`, data);
  return res.data;
};

export const getBowlingType = async () => {
  const res = await api.get(`${url}/public/bowling`);
  return res.data;
};

export const getBattingType = async () => {
  const res = await api.get(`${url}/public/batting`);
  return res.data;
};

export const getBatch = async () => {
  const res = await api.get(`${url}/public/player/batch`);
  return res.data;
};

export const getPlayingExperience = async () => {
  const res = await api.get(`${url}/public/player/experience`);
  return res.data;
};

export const getGender = async () => {
  const res = await api.get(`${url}/public/gender`);
  return res.data;
};
//stat api

export const getStaff = async (page, size, search) => {
  const params = { page, size };

  if (search) {
    params.search = search;
  }
  const res = await api.get(`${url}/staff/search`, {
    params,
  });
  return res.data;
};

export const createAndUpdateStaff = async (data) => {
  const res = await api.post(`${url}/staff/create`, data);
  return res.data;
};

export const downloadAllStaff = async (search) => {
  const params = { search };
  if (search) {
    params.search = search;
  }
  params.download = true;
  const res = await api.get(`${url}/staff/search`, {
    params,
  });
  return res.data;
};

//Image Upload and get

// export const uploadPlayerImage = async (data) => {
//   const res = await api.post(`${url}/player/image-upload`, data);
//   return res.data;
// };

export const uploadPlayerImage = async (file) => {
  const formData = new FormData();
  formData.append("file", file);

  try {
    const response = await api.post(`${url}/player/image-upload`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    console.error("File upload failed:", error);
    throw error;
  }
};

export const uploadPlayerForm = async (file) => {
  const formData = new FormData();
  formData.append("file", file);

  try {
    const response = await api.post(`${url}/player/form-upload`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    console.error("File upload failed:", error);
    throw new Error("File upload failed");
  }
};

export const getImageByFileName = async (fileName) => {
  const res = await api.get(`${url}/player/upload?filename=${fileName}`);
  return res.data;
};

// tournaments

export const getTournaments = async (page, size, search) => {
  const params = { page, size };

  if (search) {
    params.search = search;
  }
  const res = await api.get(`${url}/tournaments`, {
    params,
  });
  return res.data;
};

export const createAndUpdateTournaments = async (data) => {
  const res = await api.post(`${url}/tournaments`, data);
  return res.data;
};

export const getBallType = async () => {
  const res = await api.get(`${url}/public/ball/type`);
  return res.data;
};

export const getMatchType = async () => {
  const res = await api.get(`${url}/public/match/type`);
  return res.data;
};

export const getDashboardStats = async () => {
  const res = await api.get(`${url}/dashboard/stats`);
  return res.data;
};

export const getDashboardSummary = async () => {
  const res = await api.get(`${url}/dashboard/summary`);
  return res.data;
};

export const getPackageSummary = async (startDate, endDate) => {
  const params = {};

  if (startDate) {
    params.fromDate = startDate;
  }
  if (endDate) {
    params.toDate = endDate;
  }

  const res = await api.get(`${url}/dashboard/package/purchased/summary`, {
    params,
  });
  return res.data;
};

export const getRegistrationSummary = async (startDate, endDate) => {
  const params = {};

  if (startDate) {
    params.fromDate = startDate;
  }
  if (endDate) {
    params.toDate = endDate;
  }

  const res = await api.get(`${url}/dashboard/registration/summary`, {
    params,
  });
  return res.data;
};

export const getHighDemandPackages = async (startDate, endDate) => {
  const params = {};

  if (startDate) {
    params.fromDate = startDate;
  }
  if (endDate) {
    params.toDate = endDate;
  }

  const res = await api.get(`${url}/dashboard/high/demand/packages`, {
    params,
  });
  return res.data;
};

export const getPackagesByPayments = async (startDate, endDate) => {
  const params = {};

  if (startDate) {
    params.fromDate = startDate;
  }
  if (endDate) {
    params.toDate = endDate;
  }

  const res = await api.get(`${url}/dashboard/package/wise/payment`, {
    params,
  });
  return res.data;
};

export const getUpcomingDues = async () => {
  const res = await api.get(`${url}/dashboard/upcoming/renewals`);
  return res.data;
};

export const getOverDueSummary = async () => {
  const res = await api.get(`${url}/dashboard/overdue/summary`);
  return res.data;
};

export const getRemidersSent = async () => {
  const res = await api.get(`${url}/dashboard/reminder/summary`);
  return res.data;
};

export const getPaymentModeSummary = async () => {
  const res = await api.get(`${url}/dashboard/payment/mode/summary`);
  return res.data;
};

// FAQs
export const getFaqCategories = async () => {
  const res = await api.get(`${url}/master/all/faqs/categories`);
  return res.data;
};

export const createFaqCategory = async (data) => {
  const res = await api.post(`${url}/master/faq/category`, data);
  return res.data;
};

export const getFaqs = async (page, size, search) => {
  const params = { page, size };
  if (search) {
    params.search = search;
  }
  const res = await api.get(`${url}/master/all/faqs`, {
    params,
  });
  return res.data;
};

export const createAndUpdateFaqs = async (data) => {
  const res = await api.post(`${url}/master/faq`, data);
  return res.data;
};

//income-expensive

export const createIncomeExpensive = async (data) => {
  const res = await api.post(`${url}/master/expensive/report`, data);
  return res.data;
};

export const getAllIncomeExpensive = async (page, size, search) => {
  const params = { page, size };
  if (search) {
    params.search = search;
  }
  const res = await api.get(`${url}/master/expensive/reports`, {
    params,
  });
  return res.data;
};

export const getAllIncomeExpensiveDownload = async (search) => {
  const params = { search };
  if (search) {
    params.search = search;
  }
  params.download = true;

  const res = await api.get(`${url}/master/expensive/reports`, {
    params,
  });
  return res.data;
};

//cashbook category
export const getCashBookCategories = async () => {
  const res = await api.get(`${url}/master/all/expensive/categories`);
  return res.data;
};

export const createCaseBookCategory = async (data) => {
  const res = await api.post(`${url}/master/expensive/category`, data);
  return res.data;
};

//items
export const getCashBookItems = async () => {
  const res = await api.get(`${url}/master/all/expensive/items`);
  return res.data;
};

export const getCashBookItemByCategory = async (categoryId) => {
  const res = await api.get(
    `${url}/master/expensive/items/category/${categoryId}`,
  );
  return res.data;
};

export const createCaseBookItem = async (data) => {
  const res = await api.post(`${url}/master/expensive/item`, data);
  return res.data;
};

export const getPaymentMode = async () => {
  const res = await api.get(`${url}/public/paymentType`);
  return res.data;
};

export const getPlayerPaymentReceiptById = async (id) => {
  const res = await api.get(`${url}/player/payment/receipt/${id}`);
  return res.data;
};

export const getPlayerRecentPaymentReceiptById = async (id) => {
  const res = await api.get(`${url}/player/recent/receipt/${id}`);
  return res.data;
};

export const getPlayerRecentPaymentReceiptByHistoryId = async (id) => {
  const res = await api.get(`${url}/player/payment/receipt/history/${id}`);
  return res.data;
};

//my tenants

export const getMyAllTenant = async (page, size, search) => {
  const params = { page, size };

  if (search) {
    params.search = search;
  }

  const res = await api.get(`${url}/my/tenant`, { params });
  return res.data;
};

export const createMyTenant = async (data) => {
  const res = await api.post(`${url}/my/tenant`, data);
  return res.data;
};

export const updateMyTenant = async (data) => {
  const res = await api.put(`${url}/my/tenant/${data.id}`, data);
  return res.data;
};

export const getAdminGatewayByTenantId = async (tenantId) => {
  const res = await api.get(`${url}/my/tenant/payment/config/${tenantId}`);
  return res.data;
};

// Same API for CREATE + UPDATE
export const saveRazorpayGateway = async (payload) => {
  const response = await api.post(`${url}/my/tenant/payment/config`, payload);
  return response.data;
};

export const saveCcavenueGateway = async (payload) => {
  const response = await api.post(
    `${url}/my/tenant/ccAvenue/payment/config`,
    payload,
  );

  return response.data;
};

export const updateGatewayStatus = async (id) => {
  const response = await api.post(
    `${url}/my/tenant/payment/config/status/${id}`,
  );

  return response.data;
};

export const createRazorpayTenantOrder = async (data) => {
  const res = await api.post(
    `${url}/public/create/tenant/order?tenantId=${data}`,
  );
  return res.data;
};

export const razorpayTenantOrderVerify = async (data) => {
  const res = await api.post(`${url}/public/verify/tenant/payment`, data);
  return res.data;
};

export const createMyTenantRazorpayData = async (data) => {
  const res = await api.post(`${url}/my/tenant/payment/config`, data);
  return res.data;
};

export const getMyTenantRazorpayData = async (tenantId) => {
  const res = await api.get(`${url}/my/tenant/payment/config/${tenantId}`);
  return res.data;
};

//reports
export const getPlayersFeeCollection = async (page, size, search) => {
  const params = { page, size };

  if (search) {
    params.search = search;
  }
  const res = await api.get(`${url}/report/player/payment/history`, {
    params,
  });
  return res.data;
};

export const getDuesPlayersInvoice = async (
  page,
  size,
  search,
  selectedPackage,
  selectedPlayer,
  startDate,
  endDate,
) => {
  const params = { page, size };

  if (search) {
    params.search = search;
  }
  if (selectedPackage) {
    params.subscriptionId = selectedPackage;
  }
  if (selectedPlayer) {
    params.playerId = selectedPlayer;
  }
  // if (selectedPaymentStatus) {
  //   params.paymentStatus = selectedPaymentStatus;
  // }

  if (startDate) {
    params.fromDate = startDate;
  }

  if (endDate) {
    params.toDate = endDate;
  }

  const res = await api.get(`${url}/report/player/pending/bills`, {
    params,
  });
  return res.data;
};

export const ReportPlayerPayment = async (data) => {
  const res = await api.post(`${url}/report/add/player/payment`, data);
  return res.data;
};

//coach api

export const getCoachAttendanceByLogin = async (
  page,
  size,
  search,
  startDate,
  endDate,
  selectedSession,
  selectedStatus,
) => {
  const params = { page, size };

  if (search) {
    params.search = search;
  }
  if (startDate) {
    params.fromDate = startDate;
  }
  if (endDate) {
    params.toDate = endDate;
  }
  if (selectedSession) {
    params.sessionId = selectedSession;
  }
  if (selectedStatus) {
    params.status = selectedStatus;
  }

  const res = await api.get(`${url}/coach/attendance/records`, {
    params,
  });
  return res.data;
};

export const getPlayersAttendanceByLogin = async (
  page,
  size,
  search,
  startDate,
  endDate,
  selectedSession,
  selectedStatus,
) => {
  const params = { page, size };

  if (search) {
    params.search = search;
  }
  if (startDate) {
    params.fromDate = startDate;
  }
  if (endDate) {
    params.toDate = endDate;
  }
  if (selectedSession) {
    params.sessionId = selectedSession;
  }
  if (selectedStatus) {
    params.status = selectedStatus;
  }

  const res = await api.get(`${url}/player/attendance`, {
    params,
  });
  return res.data;
};

export const getPlayerPaymentHistoryByLogin = async (page, size, search) => {
  const params = { page, size };

  if (search) {
    params.search = search;
  }
  const res = await api.get(`${url}/player/payment/history`, {
    params,
  });
  return res.data;
};

export const updateProfile = async (data) => {
  const res = await api.put(`${url}/users/update/profile`, data);
  return res.data;
};

export const uploadAvatar = async (data) => {
  const res = await api.put(`${url}/users/upload/avatar`, data);
  return res.data;
};
